/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marketing_Dev_BodyInputs */

const en_marketing_dev_body = /** @type {(inputs: Marketing_Dev_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Local dev simulates the whole platform: the database, storage, queues, Durable Objects, cron triggers, and workflows all run on your machine with no cloud account. Foundations only stay healthy where they can be exercised.`)
};

const es_marketing_dev_body = /** @type {(inputs: Marketing_Dev_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El entorno local simula toda la plataforma: la base de datos, el almacenamiento, las colas, los Durable Objects, los cron triggers y los flujos de trabajo se ejecutan en tu máquina sin ninguna cuenta en la nube. Las bases solo se mantienen sanas allí donde se pueden ejercitar.`)
};

const fr_marketing_dev_body = /** @type {(inputs: Marketing_Dev_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'environnement local simule toute la plateforme : la base de données, le stockage, les files, les Durable Objects, les cron triggers et les workflows tournent sur votre machine sans aucun compte cloud. Une fondation ne reste saine que là où on peut l'exercer.`)
};

/**
* | output |
* | --- |
* | "Local dev simulates the whole platform: the database, storage, queues, Durable Objects, cron triggers, and workflows all run on your machine with no cloud ac..." |
*
* @param {Marketing_Dev_BodyInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" }} options
* @returns {LocalizedString}
*/
export const marketing_dev_body = /** @type {((inputs?: Marketing_Dev_BodyInputs, options?: { locale?: "en" | "es" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marketing_Dev_BodyInputs, { locale?: "en" | "es" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_marketing_dev_body(inputs)
	if (locale === "es") return es_marketing_dev_body(inputs)
	return fr_marketing_dev_body(inputs)
});